<template>
	<div>
		<div class="search-container u-container">
			<div class="search-item search-item--date">
				<input
					v-model="startVal"
					@click="openDatepicker"
					type="text"
					autocomplete="off"
					readonly
				/>
				<i class="ri-calendar-line"></i>
			</div>
			<div class="search-item search-item--text">~</div>
			<div class="search-item search-item--date">
				<input
					v-model="endVal"
					@click="openDatepicker"
					type="text"
					autocomplete="off"
					readonly
				/>
				<i class="ri-calendar-line"></i>
			</div>
			<div class="search-item search-item--button">
				<Btn color="primary" type="submit" medium block>조회</Btn>
			</div>
		</div>

		<div
			:class="{ 'is-open': isOpenDatepicker }"
			class="search-calender-container"
		>
			<v-date-picker
				@input="onDateRangeChange"
				v-model="range"
				:min-date="getMinDate"
				:max-date="getMaxDate"
				color="gray"
				is-expanded
				is-range
				is-inline
			></v-date-picker>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';

import VCalendar from 'v-calendar';
import '@/assets/css/custom-v-calendar.css';

Vue.use(VCalendar);

import { getDateStr } from '@/utils/util';

import Btn from '@/components/common/Btn';

const INIT_SEARCH_RANGE_MONTH = 3; // 조회 시작 날짜 기본 범위
const SEARCH_LIMIT_RANGE_MONTH = 24; // 조회 가능한 시작 날짜 범위

export default {
	components: {
		Btn,
	},
	data() {
		return {
			isOpenDatepicker: false,
			range: {
				start: '',
				end: '',
			},
			inputValue: {
				start: '',
				end: '',
			},
		};
	},
	computed: {
		startVal() {
			return getDateStr(this.range.start, 'comma');
		},
		endVal() {
			return getDateStr(this.range.end, 'comma');
		},
		getMinDate() {
			const year = new Date().getFullYear();
			const d1 = new Date(year, 0, 1);
			d1.setMonth(d1.getMonth() - SEARCH_LIMIT_RANGE_MONTH);
			return d1;
		},
		getMaxDate() {
			return new Date();
		},
	},
	methods: {
		init() {
			this.initRangeDate();
		},
		initRangeDate() {
			this.range.end = new Date();

			const startDate = new Date();
			startDate.setMonth(startDate.getMonth() - INIT_SEARCH_RANGE_MONTH);
			this.range.start = startDate;
		},
		// 데이트피커 열기
		openDatepicker() {
			this.isOpenDatepicker = true;
		},
		// 데이트피커 기간 설정 콜백
		onDateRangeChange() {
			// 데이트피커 닫기
			this.isOpenDatepicker = false;
		},
	},
	created() {
		this.init();
	},
};
</script>

<style scoped>
.search-container {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	padding: 1rem 0;
}

.search-item--date {
	display: flex;
	justify-content: space-between;
	flex: 0 0 35%;
	border-bottom: 1px solid #c8c8c8;
}

.search-item--date input[type='text'],
.search-item--date i {
	height: 2.5rem;
}

.search-item--date input[type='text'] {
	width: 100%;
	padding: 0 0.3125rem;
	border: 0;
	font-size: 0.875rem;
}

.search-item--date i {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0 0.3125rem;
	color: #c8c8c8;
	font-size: 1.375rem;
	cursor: pointer;
}

.search-item--text {
	flex: 1;
	color: #222;
	font-size: 1.25rem;
	text-align: center;
}

.search-item--button {
	flex: 0 0 20%;
	padding-left: 0.875rem;
}

.search-item--button button {
	width: 100%;
	height: 100%;
}

.search-calender-container {
	display: none;
	position: fixed;
	left: 0;
	right: 0;
	z-index: 5000;
	bottom: 3.75rem;
}

.search-calender-container.is-open {
	display: block;
}
</style>
